import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { statusObj } from 'src/app/dummy/status';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { pageKey, toNumber, MappingService } from 'src/app/services/mapping.service';
import { List } from 'src/app/stores/administrator/list.store';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { IClassSchedule } from 'src/app/interfaces/enrollment';
import { ConvertService } from 'src/app/services/convert.service';
import { Observable } from 'rxjs';
import { ClassroomStore } from 'src/app/stores/enrollment/classroom.store';

@Component({
  selector: 'app-add-schedule',
  templateUrl: './add-schedule.component.html',
  styleUrls: ['./add-schedule.component.scss']
})
export class AddScheduleComponent implements OnInit {
  @ViewChild('focusInput', { static: false }) inputEl: ElementRef;

  form: FormGroup;
  subject: AbstractControl;
  code: AbstractControl;
  limit: AbstractControl;
  tutor: AbstractControl;
  shift: AbstractControl;
  session: AbstractControl;
  note: AbstractControl;

  filteredSubjectStates: Observable<any[]>;
  filteredTutorStates: Observable<any[]>;
  filteredSessionStates: Observable<any[]>;
  filteredShiftStates: Observable<any[]>;

  process: boolean = true;
  constructor(public dialogRef: MatDialogRef<AddScheduleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public auth: AuthStore,
    public ds: DataService,
    private snackBar: MatSnackBar,
    public list: List,
    public store: ClassroomStore,
  ) { }

  buildForm(): void {
    this.form = this.fb.group({
      subject: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      code: [null, Validators.required],
      limit: [30, Validators.required],
      tutor: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      shift: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      session: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      note: [null],
    });
    this.subject = this.form.controls['subject'];
    this.code = this.form.controls['code'];
    this.limit = this.form.controls["limit"];
    this.tutor = this.form.controls["tutor"];
    this.shift = this.form.controls["shift"];
    this.session = this.form.controls["session"];
    this.note = this.form.controls["note"];
  }

  async ngOnInit() {
    this.buildForm();

    const subjectData = await this.list.fetchList(this.ds.subjectRef());
    const tutorData = await this.list.fetchList(this.ds.tutorRef());
    const shiftData = await this.list.fetchList(this.ds.shiftRef());

    this.filteredSubjectStates = MappingService.autoComplete(this.subject, subjectData, "name");
    this.filteredTutorStates = MappingService.autoComplete(this.tutor, tutorData, "fullname");
    this.filteredShiftStates = MappingService.autoComplete(this.shift, shiftData, "name");

    this.process = false;
  }

  compareObjects(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.key === o2.key : o1 === o2;
  }

  displayItem(item: any): string {
    return item ? item.name : item;
  }

  displayItemFullName(item: any): string {
    return item ? item.fullname : item;
  }

  async onSelectShift(event) {
    const { value } = event.option;
    this.session.patchValue(null);

    if (value) {

      const sessionData = await this.list.fetchList(this.ds.sessionByShiftRef(value.key));
      this.filteredSessionStates = MappingService.autoComplete(this.session, sessionData, "name");;
    }
  }

  create(f: any, isNew) {
    if (this.form.valid) {
      const { code, note, limit, subject, session, shift, tutor } = f;
      const item: IClassSchedule = {
        key: this.ds.createId(),
        page_key: pageKey(),
        created_at: new Date(),
        created_byRef: this.ds.userRef().doc(`${this.auth.user.uid}`).ref,
        created_by: this.auth.user.uid,
        updated_at: new Date(),
        updated_byRef: this.ds.userRef().doc(`${this.auth.user.uid}`).ref,
        updated_by: this.auth.user.uid,
        isDelete: false,
        status: statusObj.active,
        keyword: ConvertService.toCapitalize(`${code.trim()}`),

        code,
        note,
        totalEnroll: 0,
        limit: toNumber(limit),
        subjectKey: subject.key,
        subjectRef: this.ds.subjectRef().doc(`${subject.key}`).ref,
        tutorKey: tutor.key,
        tutorRef: this.ds.tutorRef().doc(`${tutor.key}`).ref,
        shiftKey: shift.key,
        shiftRef: this.ds.shiftRef().doc(`${shift.key}`).ref,
        sessionKey: session.key,
        sessionRef: this.ds.sessionRef().doc(`${session.key}`).ref,

        classRoomKey: this.store.selectedClass.key,
        classRoomRef: this.ds.classRoomRef().doc(`${this.store.selectedClass.key}`).ref,
      };

      this.store.addSchedule(item, (success, error) => {
        if (success) {
          if (!isNew) {
            this.dialogRef.close();
          }
          this.snackBar.open('Schedule has been created successfully.', 'done', { duration: 2000 });
          this.form.reset();
        } else {
          this.snackBar.open(error, 'Error');
        }
      });

    }
  }

}
